// @flow
import React from 'react'
import createIcon from 'mz-icons/utils/createIcon'

export default createIcon({
  iconName: 'dinner',
  icon: [
    29,
    19,
    null,
    null,
    null,
    <g id="diners" fillRule="nonzero" key="dinner">
      <path
        d="M26.58,19 L2.42,19 C1.78347383,19.0053265 1.17090452,18.7575644 0.717061656,18.311223 C0.263218789,17.8648817 0.00528228465,17.2565265 0,16.62 L0,2.38 C0.00528228465,1.74347346 0.263218789,1.13511831 0.717061656,0.688776978 C1.17090452,0.242435646 1.78347383,-0.00532648787 2.42,4.4408921e-16 L26.58,4.4408921e-16 C27.2165262,-0.00532648787 27.8290955,0.242435646 28.2829383,0.688776978 C28.7367812,1.13511831 28.9947177,1.74347346 29,2.38 L29,16.63 C28.9835257,17.9515828 27.9016388,19.0111167 26.58,19 Z"
        id="shape"
        fill="#EBF1F8"
      />
      <path
        d="M12,2.02 L12,2 L17,2 L17,2.02 C20.9192925,2.30679857 23.9526427,5.57022816 23.9526427,9.5 C23.9526427,13.4297718 20.9192925,16.6932014 17,16.98 L17,17 L12,17 L12,16.98 C8.08070755,16.6932014 5.04735729,13.4297718 5.04735729,9.5 C5.04735729,5.57022816 8.08070755,2.30679857 12,2.02 Z"
        id="shape"
        fill="#0165AC"
      />
      <path
        d="M14,13.74 C15.7941076,13.1021405 16.9925518,11.4041236 16.9925518,9.5 C16.9925518,7.59587637 15.7941076,5.89785949 14,5.26 L14,13.74 L14,13.74 Z M11,5.26 C9.20589241,5.89785949 8.00744817,7.59587637 8.00744817,9.5 C8.00744817,11.4041236 9.20589241,13.1021405 11,13.74 L11,5.26 L11,5.26 Z M12.5,16 C8.91014913,16 6,13.0898509 6,9.5 C6,5.91014913 8.91014913,3 12.5,3 C16.0898509,3 19,5.91014913 19,9.5 C19,13.0898509 16.0898509,16 12.5,16 Z"
        id="shape"
        fill="#FFFFFF"
      />
    </g>,
  ],
})
